export default {
    data() {
        return {
            url: this.$serverURL + this.$api.cms.storeDetailsCmsURL,
            cmsData: {},
            preview: {
                bannerImage: "",
                accessableIcon: "",
                atmIcon: "",
                minimumageIcon: "",
                brandVerifiedIcon: "",
            }
        }
    },
    async created() {
        document.title = "Dispo - Store Details CMS";
        this.getData();
    },
    methods: {
        async getData() {
            let response = await this.getCmsData(this.url);
            if (response.statusCode == 200) {
                this.cmsData = (response.data.length > 0) ? response.data[0] : {};
            }
            else {
                this.cmsData = {};
            }
        },
        handleUploadImage(imageKey, previewImageKey, ref, event) {
            this.cmsData[imageKey] = event.target.files[0];
            let input = this.$refs[ref];
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader
                reader.onload = e => {
                    this.preview[previewImageKey] = e.target.result
                }
                reader.readAsDataURL(file[0])
            }
        },
        async updateCms() {
            try {
                let fromData = new FormData();
                fromData.append('amenitiesTitle', this.cmsData.amenitiesTitle);
                fromData.append('bannerImage', this.cmsData.bannerImage);
                fromData.append('accessableIcon', this.cmsData.accessableIcon);
                fromData.append('atmIcon', this.cmsData.atmIcon);
                fromData.append('minimumageIcon', this.cmsData.minimumageIcon);
                fromData.append('brandVerifiedIcon', this.cmsData.brandVerifiedIcon);
                this.$swal.showLoading();
                let response = await this.createUpdateCMS(this.url, fromData);
                if (response.statusCode == 200 || response.statusCode == 201) {
                    this.$refs.bannerImage.value = null;
                    this.$refs.accessableIcon.value = null;
                    this.$refs.atmIcon.value = null;
                    this.$refs.minimumageIcon.value = null;
                    this.$refs.brandVerifiedIcon.value = null;
                    this.preview = {
                        bannerImage: "",
                        accessableIcon: "",
                        atmIcon: "",
                        minimumageIcon: "",
                        brandVerifiedIcon: "",
                    }
                    this.$swal.fire({
                        toast: true,
                        position: 'top-end',
                        text: response.message,
                        icon: "success",
                        showConfirmButton: false,
                        timer: 3000,
                        animation: false,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', this.$swal.stopTimer)
                            toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                        }
                    });
                }
                await this.getData();
            } catch (error) {
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            } finally {
                this.$swal.hideLoading();
            }
        }
    }
}